/**
 * Game Result Detection Utility
 * 
 * Determines the result (WON, LOST, ABANDONED) for each player in a game.
 * Used for players_session_games table.
 */

/**
 * Determines the result for a player based on their team and the game outcome
 * @param {number} playerTeamNumber - The team number the player is on (1 or 2)
 * @param {number} winningTeam - The winning team number (1 or 2)
 * @param {string} gameStatus - The status of the game ('completed', 'abandoned', etc.)
 * @returns {string} The result ('win', 'loss', or 'abandoned')
 */
export const detectPlayerResult = (playerTeamNumber, winningTeam, gameStatus = 'completed') => {
  // If game was abandoned, all players get 'abandoned'
  if (gameStatus === 'abandoned') {
    return 'abandoned';
  }

  // Determine if player's team won
  if (playerTeamNumber === winningTeam) {
    return 'win';
  } else {
    return 'loss';
  }
};

/**
 * Gets a human-readable description of the result
 * @param {string} result - The result
 * @returns {string} Human-readable description
 */
export const getResultDescription = (result) => {
  const descriptions = {
    'win': 'Won the game',
    'loss': 'Lost the game',
    'abandoned': 'Game was abandoned'
  };
  
  return descriptions[result] || 'Unknown result';
};

/**
 * Validates if a result is valid
 * @param {string} result - The result to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidResult = (result) => {
  const validResults = ['win', 'loss', 'abandoned'];
  return validResults.includes(result);
}; 